export default __webpack_public_path__ + "static/media/Wook_AIBrain.fd516aff.png";